import { render, staticRenderFns } from "./m-uploads.vue?vue&type=template&id=230e8df8&scoped=true&"
import script from "./m-uploads.vue?vue&type=script&lang=js&"
export * from "./m-uploads.vue?vue&type=script&lang=js&"
import style0 from "./m-uploads.vue?vue&type=style&index=0&id=230e8df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e8df8",
  null
  
)

export default component.exports